// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__KUJT2","bigColWidth":"Table_bigColWidth__1INoX","biggerColWidth":"Table_biggerColWidth__3BPGy","row":"Table_row__2WaNM","col":"Table_col__sAGBz"};